import clsx from 'clsx';
import { SelectableClient } from '../../../services/SelectClient/selectClient.service';
import styles from './clientOption.module.scss';

interface ClientOptionProps {
  client: SelectableClient;
  isSelected: boolean;
  onSelect: (client: SelectableClient) => void;
}

const ClientOption = ({ client, isSelected, onSelect }: ClientOptionProps) => {
  const handleClick = () => onSelect(client);

  return (
    <button type="button" className={clsx(styles.option, isSelected && styles.optionSelected)} aria-pressed={isSelected} onClick={handleClick}>
      {client.name}
    </button>
  );
};

export default ClientOption;
